import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import imageHelper from '@utils/imageHelper';
import { Context as IsMobileContext } from '../../../Context/IsMobileContext';
import { Spacings, Fonts, mobile } from '../../../../styleConstants';
import SectionTitle from '../SectionTitle';
import SummitDate from '../SummitDate';
import RegisterButton from '../RegisterButton';
import ContentContainer from '../ContentContainer';

const Wrapper = styled.section`
  display: grid;
  grid-template: 1fr / 1fr max-content;
  grid-column-gap: 200px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    display: block;
    text-align: center;
    margin-top: 120px;
  }
`;

const InfoContainer = styled.div``;

const StyledTitle = styled(SectionTitle)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const Image = styled.img.attrs(() => ({
  src: imageHelper.getImage('summit/footer_bg.svg'),
  alt: 'take the summit advantage'
}))`
  height: 252px;
  align-self: center;
  user-drag: none;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: 100%;
    height: auto;
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const StyledButton = styled(RegisterButton)`
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-left: auto;
    margin-right: auto;
  }
`;

const SummitFooter = ({ scheduleRef }) => {
  const isMobileDevice = useContext(IsMobileContext);
  const staticTexts = useSelector(({ summit }) => summit.staticTexts || {});
  return (
    <ContentContainer as={Wrapper}>
      <InfoContainer>
        <StyledTitle $size={isMobileDevice ? Fonts.H2 : Fonts.H1}>
          {staticTexts.footerHeader || ''}
        </StyledTitle>
        {isMobileDevice && <Image />}
        <SummitDate />
        <StyledButton scheduleRef={scheduleRef} />
      </InfoContainer>
      {!isMobileDevice && <Image />}
    </ContentContainer>
  );
};

SummitFooter.propTypes = {
  scheduleRef: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitFooter;
